import React from "react";
import { connect } from "react-redux";
import Swiper from "swiper";
import "../../css/ProductSlider.css";
import ArrowUpAndDown from "../../images/common/ui/arrow_up.png";
import DiscoveryIcon from "../../images/discovery icon.svg";

let $ = window.$;
let galleryBig;
let galleryThumbs;

class Left extends React.Component {
  state = {
    showVideo: true,
    play: true
  };
  videoPlay = () => {
    const videoIndex = galleryBig.slides.length;
    galleryBig.slideTo(videoIndex);
  };
  componentDidMount() {
    galleryThumbs = new Swiper(".gallery-thumbs", {
      direction: "vertical",
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".vert-button-next",
        prevEl: ".vert-button-prev"
      },
      breakpoints: {
        1199: {
          // slidesPerView: 4
        },
        991: {
          // slidesPerView: 3
        }
      }
    });
    galleryBig = new Swiper(".gallery-big", {
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".gallery-big-button-next",
        prevEl: ".gallery-big-button-prev"
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
    $(document).ready(function () {
      $(".zoom").zoom();
    });

    galleryBig.on("slideChange", () => {
      const { video } = this.props;
      const index = galleryBig.activeIndex + 1;
      const length = galleryBig.slides.length;
      const isLast = index === length;
      if (video) {
        const videoElement = document.getElementById("pdtVideo");
        if (isLast) {
          videoElement.play();
          this.setState({
            play: true
          });
        } else {
          videoElement.pause();
          this.setState({
            play: false
          });
        }
      }
    });

    galleryThumbs.on("click", () => {
      this.setState({ play: true });
    });
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.gallery &&
      this.props.gallery &&
      prevProps.gallery !== this.props.gallery
    ) {
      galleryBig.update();
      galleryThumbs.update();
      galleryBig.slideTo(0);
      galleryThumbs.slideTo(0);
    }
    await $(".zoom").trigger("zoom.destroy");
    $(".zoom").zoom();
  }

  handleVideoPlay = () => {
    const { play } = this.state;
    const video = document.getElementById("pdtVideo");
    if (play) {
      video.pause();
      this.setState({
        play: false
      });
    } else {
      video.play();
      this.setState({
        play: true
      });
    }
  };

  render() {
    const { gallery, video } = this.props;
    const { showVideo } = this.state;
    const url = window.location.pathname;
    const sku = url.substring(url.lastIndexOf("/") + 1);
    const showoff = gallery.length < 6;

    return (
      <>
        <div className="pdt_L_wrap">
          <div className="pdt_thm_wrap">
            <div className="gallery-thumbs_wrap">
              <div
                className={`vert-button-prev ${showoff ? "show-off" : ""}`}
                style={{
                  backgroundImage: `url(${ArrowUpAndDown})`,
                  backgroundSize: "auto 1.5rem",
                  height: "2.25rem"
                }}
              />
              <div className="swiper-container gallery-thumbs">
                <div className="swiper-wrapper">
                  {gallery.map((img, index) => (
                    <div
                      key={index}
                      className="swiper-slide"
                      style={{
                        backgroundImage: `url(${img.zoomOutUrl})`
                      }}
                    />
                  ))}
                </div>
              </div>
              <div
                className={`vert-button-next ${showoff ? "show-off" : ""}`}
                style={{
                  backgroundImage: `url(${ArrowUpAndDown})`,
                  backgroundSize: "auto 1.5rem",
                  height: "2.25rem"
                }}
              />
            </div>
          </div>
          {video && (
            <div
              className="gallery-thumb-video-btn imageSize2VideoDiv"
              onClick={this.videoPlay}
            >
              <img src={gallery[0].zoomOutUrl} alt="" />
            </div>
          )}
        </div>
        <div className="pdt_M_wrap">
          <div className="pdt_bigImg_wrap">
            <div
              className="swiper-container gallery-big"
              style={{ height: "auto" }}
            >
              <div className="swiper-wrapper">
                {gallery.map((img, index) => (
                  <div key={index} className="swiper-slide">
                    <span className="zoom">
                      <img src={img.zoomInUrl} alt="" />
                    </span>
                    {/* 暫時移除syte相關模組 */}
                    {/* <button
                      className="syte-discovery pdp-syte-discovery"
                      data-image-src={img.displayUrl}
                      data-sku={sku}
                      data-placement="product-detail-page"
                    >
                      <img src={DiscoveryIcon} alt="" />
                    </button> */}
                  </div>
                ))}
                {(video && showVideo && (
                  <div
                    className="swiper-slide swiper-slide-video"
                    onClick={this.handleVideoPlay}
                  >
                    <video id="pdtVideo" loop key={video} playsInline>
                      <source src={video} type="video/mp4" />
                    </video>
                    {!this.state.play && (
                      <div className="video-pause-commit-icon" />
                    )}
                  </div>
                )) ||
                  null}
              </div>
            </div>
            <div className="swiper-button-next gallery-big-button-next"></div>
            <div className="swiper-button-prev gallery-big-button-prev"></div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    productLoading: state.product.loading,
    video: state.product.productBookingUnit.media.video
  };
};
export default connect(mapStateToProps)(Left);
